module.exports = __webpack_public_path__ + "img/more_multi.0b452ca6.jpg";